export default "__VITE_ASSET__DCAcfGYO__"